import React from "react";
import Header from "../components/Layout/Header";
import Sidebar from "../components/Layout/Sidebar";
import CondicaoComercialViewer from "../components/CondicaoComercial/CondicaoComercialViewer";

function CondicaoComercial() {
  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
          <CondicaoComercialViewer />
        </main>
      </div>
    </div>
  );
}

export default CondicaoComercial;
